import axios from 'axios';
import { Toast } from 'vant';
import { encryptDataForSign } from '@/utils/encrypt';

axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;

const request = axios.create({});

// 请求拦截器
request.interceptors.request.use(
  config => {
    if (config.url?.includes('market-cms') && config.headers) {
      config.headers['Content-Type'] = 'application/json';
      // 获取验签信息
      if (config.url === '/market-cms/common/setcookie') {
        if (config.params !== undefined) {
          Object.assign(config.params, {
            _t: new Date().getTime()
          });
        } else {
          config.params = {
            _t: new Date().getTime()
          };
        }
        const { encryptString, timeStamp, sortObject, xver } = encryptDataForSign({
          object: config.params,
          method: 'get'
        });

        if (xver !== -99) {
          config.params = sortObject;
          config.headers = {
            ...config.headers,
            'x-ts': timeStamp,
            'x-ver': xver,
            'x-sn': encryptString,
            hostname: window.location.hostname
          };
        }
      }
    }
    return config;
  },
  error => {
    Toast.fail(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  res => {
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.result);
    }
    Toast.fail(res.data.errmsg);
    return Promise.reject(res);
  },
  error => {
    console.log(error);
    if (error.res !== undefined) {
      Toast.fail(`服务异常 ${error.res.status}`);
      return Promise.reject(error);
    } else {
      const code = error.toString().match(/\d+/g);
      Toast.fail(`服务异常 ${code}`);
    }
    return Promise.reject(error);
  }
);

export default {
  get(url, params) {
    if (params !== undefined) {
      Object.assign(params, { _t: new Date().getTime() });
    } else {
      // eslint-disable-next-line no-param-reassign
      params = { _t: new Date().getTime() };
    }
    return request({ method: 'get', url, params });
  },

  // 不常更新的数据用这个
  getData(url, params) {
    return request({ method: 'get', url, params });
  },

  post(url, params, config) {
    return request.post(url, params, config);
  }
};
